import {Component, HostListener, Inject, OnInit,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, UserService,} from '../../_services/index';

import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

import {LoginHelper, Role} from '../../helpers';
import {DOCUMENT} from "@angular/common";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {TrainingService} from "../../_services/training.service";

const defaultDialogConfig = new MatDialogConfig();

@Component({
    standalone: false,
  selector: "trainings-component",
  templateUrl: 'trainings.component.html',
  styleUrls: ['./trainings.component.scss'],
})

export class TrainingsComponent implements OnInit {
  api = window.location.origin;
  quizForm: FormGroup;
  items: any[];
  trainingId: number = null;
  trainings = [];
  canEdit: boolean = false;
  quiz: any;
  tenantName: string;
  userToken: string = LoginHelper.getFileToken();
  videoAttributes = '{ "width": 100, "height": 100 }';
  isInviteVisible: boolean = false;
  expanded = true;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public userService: UserService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) public document: any,
    public _formBuilder: FormBuilder,
    public trainingService: TrainingService) {
    this.items = [{
      question: 'What should you always do with pop-up blockers?',
      answers: ['Move to the upper right corner of the screen by dragging the “X”',
        'Never click “yes,” “accept” or even “cancel.”',
        'Click “close” or “cancel”',
        'None of the above']
    },
      {
        question: 'Which does not apply when managing data backups:',
        answers: ['Recent',
          'Off-site & Secure',
          'Process Documented',
          'Encrypted',
          'Stored on Thumb Drive',
          'Verified or Tested']
      },
      {
        question: 'If you suspect a cybersecurity incident, notify your organization’s help desk and be prepared to supply the details you know and contact information but don’t do which one below:',

        answers: ['Do not attempt to investigate or remediate the incident on your own.',
          'Inform other users of the system and instruct them to stop work immediately.',
          'Disconnect power to the computer or device immediately.',
          'Unless instructed, do not power down the machine.',
          'Unless instructed, do not remove the system from the network.',
        ]
      }, {
        question: 'What is the most common way that fraud is discovered:',

        answers: ['Employee/Coworkers',
          'Anonymous',
          'Customer',
          'Vendor',
        ]
      },


      {
        question: 'Strong passwords should not contain:',
        answers: ['English upper case (A-Z) and lower case (a-z) characters',
          'Part of the user’s name',
          'Numbers (0-9)',
          'Non-alphanumeric special characters ($, !, %, ^, …)',
          'Part of the user’s license plate number',

        ]
      },


      {
        question: 'Which are the following statements about Anti-virus and Anti-spyware software are false:',

        answers: ['Anti-virus software detects certain types of malware and can destroy it before any damage is done.',
          'Install and maintain anti-virus and anti-spyware software.',
          'Be sure to update anti-virus software on an annual basis.',
          'Many free and commercial options exist.',
          'Contact your Technology Support Professional for assistance.',

        ]
      },

      {
        question: 'Which is not a symptom of a security compromise:',

        answers: ['Disk space disappears unexpectedly.',
          'Pop-ups suddenly appear, sometimes selling security software.',
          'Files or transactions appear that should not be there.',
          'You cannot access the internet.',
          'The computer slows down to a crawl.',
          'Stolen laptop: 1 stolen every 53 seconds; 97% never recovered.',
          'The mouse pointer moves by itself.',
          'The computer spontaneously shuts down or reboots.',

        ]
      }];

    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.isInviteVisible = (currentUser.role & (Role.Manager | Role.PrimaryManager)) != 0
      || (currentUser.role & Role.KingAdmin) != 0
      || (currentUser.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0;



  }

  initForm() {
    this.onResize();
    this.quiz = this.trainings.find(t => t.id == this.trainingId);
    if (this.quiz) {
      const controls = {
        name: ['', Validators.required],
        date: [new Date(), Validators.required]
      };
      this.quiz.quizData.steps.map((step, stepId) => {
          step.items.map((item, itemId) => {
            if (item.type == 'question') {
              if (item.multiple) {
                item.answers.map((answer, answerId) => {
                  controls['r' + stepId + "_" + itemId + "_" + answerId] = [null]
                })
              } else {
                controls['r' + stepId + "_" + itemId] = [null, Validators.required]
              }

            }
          })
        }
      );

      this.quizForm = this._formBuilder.group(controls);
    }
  }

  ngOnInit() {
    this.tenantName = LoginHelper.getTenantName();
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.canEdit = (currentUser.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0 ||
      (currentUser.role & (Role.Manager | Role.PrimaryManager)) != 0 ||
      (currentUser.role & Role.KingAdmin) != 0 ||
      (currentUser.role & Role.Admin) != 0;

    this.route.params.subscribe(p => {
      this.trainingId = p['trainingId'];
      this.initForm();
    })
    this.trainingService.getAllTrainings().subscribe(t => {
      this.trainings = t.filter(i => this.canEdit || (i.trainingUsers || []).find(u => u.userId == currentUser.userId));
      this.initForm()
    });
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.videoAttributes = '{ "width":  '+ (window.innerWidth - 300)+' , "height": ' +((window.innerWidth - 300) / 2)+ ' }'
  }

  send() {
    if (this.quizForm.valid) {
      const answers = {};
      const result = {
        answers: '',
        userId: JSON.parse(sessionStorage.getItem('currentUser')).userId,
        trainingId: this.trainingId,
        user: this.quizForm.value.name,
        date: this.quizForm.value.date,
      };
      this.quiz.quizData.steps.map((step, stepId) => {
        step.items.map((item, itemId) => {
          if (item.type == 'question') {
            answers['r' + stepId + "_" + itemId] = [];
            if (item.multiple) {
              item.answers.map((answer, answerId) => {
                if (this.quizForm.value['r' + stepId + "_" + itemId + "_" + answerId]) {
                  answers['r' + stepId + "_" + itemId].push(answerId);
                }
              })
            } else {
              answers['r' + stepId + "_" + itemId] = [this.quizForm.value['r' + stepId + "_" + itemId]];
            }
          }
        });
      });

      result.answers = JSON.stringify(answers);

      this.trainingService.addTrainingAnswers(result).subscribe(() => {
        this.alertService.success("Successfully saved");
      });
    }
  }

  removeTraining(id){
    this.trainingService.deleteTraining(id).subscribe(() => {
      this.trainingService.getAllTrainings().subscribe(t => {
        this.trainings = t;
        if (id == this.trainingId)
        {
          this.router.navigate(['/training']);
          return;
        }
        this.initForm()
      });
    });
  }
}
